export { ProductHit } from './ProductHit';
